import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fkytmvswoddaqldknaps.supabase.co'
const supabaseKey = 'sb_publishable_UDXHzwmVsuLcjZjDdsARLA_IwKPryEF'

export const supabase = createClient(supabaseUrl, supabaseKey)